import React, { useState } from "react";
import { useParams } from "react-router-dom";
import parse from "html-react-parser";

import Carousel from "react-grid-carousel";
import { SRLWrapper } from "simple-react-lightbox";
import BackgroundImageWithTextCard from "../../Component/BackgroundImageWithTextCard";
import HomeCarousel from "../../Component/HomeCarouselComponent";
import CustomButton from "../../Component/customButton";
import useApiRequest from "../../Component/useFetch";
import Loading from "../../Component/Spinner/spinner";
import BackgroundImageComponent from "../../Component/BackgroundImageComponent";

const NationalParksDetailspage = () => {
  const { slug } = useParams();
  const { data , isLoaded, error} = useApiRequest(`https://resania.com/parks_api/${slug}/`);
  const todos = [];
  for (const i in data.activity) {
    const x = data.activity[i];
    todos.push(x);
  }

  const photos = [];
  for (const i in data.gallery) {
    const x = data.gallery[i];

    photos.push(x);
  }

  const attraction = [];
  for (const i in data.attractions) {
    const x = data.attractions[i];

    attraction.push(x);
  }
  const [visible, setVisible] = useState(4);
  const handleShowMorePosts = () => {
    if (visible <= attraction.length) {
      setVisible((preValue) => preValue + 4);
    } else {
      setVisible(4);
    }
  };

  return isLoaded ? (   
    <div className='container h-96'>
    <Loading/>
    </div>
    ) : data ? (
    <>
      <BackgroundImageComponent
        image_url={data.park_carousel}
        title1={data.activity_name}
        button_text="Help Me Plan"
        description={data.subtitle}
        link='/resania/help-plan'
      />

      <div className="relative py-16 bg-white dark:bg-gray-700 overflow-hidden">
        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="text-lg max-w-5xl mx-auto mb-8">
            <h1 className="mb-8">
              <span className="block text-base text-center text-green-700 font-semibold tracking-wide uppercase">
                National Parks
              </span>
              <span className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl dark:text-gray-400">
                {data.activity_name}
              </span>
            </h1>
            <p className="leading-8 text-lg dark:text-gray-200">
              {parse(`${data.description}`)}
            </p>
          </div>
          <CustomButton heading="Help Plan" link="/resania/help-plan" />

          <br />
        </div>
      </div>
      <div className="container">
        {todos.map((todo, index) => (
          <>
            <div
              className=" mt-8 mb-8 relative dark:bg-gray-600 bg-gray-200 "
              key={index}
            >
              <div className="h-72 bg-gray-500 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2">
                <img alt="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"title="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"
                  className="w-full h-72 object-cover"
                  src={todo.img_url}
                />
              </div>
              <div className="relative max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8 lg:py-16 h-72">
                <div className="md:ml-auto md:w-1/2 md:pl-10 ">
                  <h2 className="text-base font-semibold uppercase tracking-wider ">
                    {" "}
                    {todo.name}
                  </h2>
                  <p className="mt-3 text-lg">{todo.item1}</p>
                  <div className="mt-8"></div>
                </div>
              </div>
            </div>
          </>
        ))}
        <br />
        <div className="relative py-16 bg-white dark:bg-gray-700 overflow-hidden">
          <div className="relative px-4 sm:px-6 lg:px-8">
            <div className="text-lg max-w-5xl mx-auto mb-8">
              <h1 className="mb-8">
                <span className="block text-base text-center text-green-700 font-semibold tracking-wide uppercase">
                  Attractions
                </span>
                <span className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl dark:text-gray-400">
                  Here you will see
                </span>
              </h1>
            </div>
            <ul
              className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8 list-none mt-10 mb-10"
            >
              {attraction.slice(0, visible).map((item, index) => (
                <li key={index} className="relative">
                  <div className="group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-yellow-700 overflow-hidden">
                    <img alt="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"title="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"
                      src={item.img_url}
                      className="object-cover pointer-events-none group-hover:opacity-75"
                    />
                  </div>
                  <p className="mt-2 block text-sm font-medium text-gray-900 truncate pointer-events-none">
                    {item.animal_name}
                  </p>
                  {item.percentage <= 50 ? (
                    <p className="block text-sm font-medium text-yellow-500 pointer-events-none">
                      {item.percentage} %
                    </p>
                  ) : (
                    <p className="block text-sm font-medium text-green-500 pointer-events-none">
                      {item.percentage} %
                    </p>
                  )}
                </li>
              ))}
            </ul>
            <div class="flex justify-center">
              <div>
                <button
                  type="button"
                  onClick={handleShowMorePosts}
                  className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-gray-50 bg-customColor hover:bg-gray-500"
                >
                  {visible <= attraction.length ? "Load More" : "Load Less"}
                </button>
              </div>
            </div>

            <br />
          </div>
        </div>
      </div>
      <br />
      <div className="container">
        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="text-lg mx-auto mb-8">
            <h1 className="mb-8">
              <span className="block text-base text-center text-green-700 font-semibold tracking-wide uppercase">
                Gallery
              </span>
            </h1>
          </div>
          <br />
          <SRLWrapper>
            <Carousel cols={2} rows={1} gap={10}>
              {photos.map((item, index) => (
                <Carousel.Item key={index}>
                  <img alt="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"title="resania travel ,safari adventure, climb kilimanjaro and zanzibar vacation , welcome"
                    src={item.img_url}
                    fluid
                    height={600}
                    className="object-cover object-center rounded shadow-2xl h-96"
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          </SRLWrapper>
        </div>
      </div>
      <div className="relative py-16 bg-white dark:bg-gray-700 overflow-hidden">
        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="text-lg max-w-5xl mx-auto mb-8">
            <h1 className="mb-8">
              <span className="block text-base text-center text-green-700 font-semibold tracking-wide uppercase">
                National Parks 
              </span>
              <span className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl dark:text-gray-400">
                Explore More National Parks 
              </span>
            </h1>
          </div>
        </div>
      </div>

      <div className="mt-8 mb-8 container">
        <BackgroundImageWithTextCard
          endpoint="parks_api/"
          link="parks"
        />
      </div>
    </>
   ) : error ? (
    <p>{error}</p> 
  ) : 'Ooops something when wrong , please refresh the page 1 ....Awkward'
};

export default NationalParksDetailspage;
